
import { layout } from '@/mixins/customLayout'
import components from '@/components'
export default {
  name: 'GridItem',
  components,
  mixins: [layout],
  props: {
    blok: {
      required: true,
      type: Object
    },
    pidPassed: {
      required: false,
      type: Number,
      default: null
    },
    shipping: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    layoutProps() {
      const flexItems = this.blok.flexItems || { classnames: [] }
      return flexItems.classnames.reduce((accumulator, rawClassName) => {
        const prop = this.formatRaw(
          rawClassName,
          this.calculateModifier(rawClassName)
        )
        return {
          ...accumulator,
          [this.constructProp(prop.layout, prop.window)]: prop.value
        }
      }, {})
    },
    computedClasses: function() {
      return this.constructClassObj(this.blok.custom_layout, this)
    }
  },
  methods: {
    calculateModifier(rawClassName) {
      // Set index modifiers for cols, offset, and order
      let modifierIndex = 0
      if (rawClassName.includes('offset')) modifierIndex = 6
      else if (rawClassName.includes('order')) modifierIndex = 5
      return modifierIndex
    },
    formatRaw(raw, idx) {
      // create three substrings from raw using the idx modifier
      const layout = raw.substring(0, idx)
      const window =
        layout !== ''
          ? raw.substring(idx + 1, idx + 3)
          : raw.substring(idx, idx + 2)
      const value = raw.substring(raw.indexOf(window) + 2)
      return {
        layout: layout,
        window: window,
        value: value
      }
    },
    constructProp(layout, window) {
      // Translate substrings to account for xs window and cols
      layout = layout === '' && window === 'xs' ? 'cols' : layout
      window = window === 'xs' ? '' : window
      // Concatenate them all together with appropriate hyphens and return
      if (layout !== '' && window !== '') return layout + '-' + window
      else return layout !== '' ? layout : window
    }
  }
}
